import styleInject from '#style-inject';styleInject(".straumur__google-pay-button__loading{display:flex;justify-content:center}\n")